import SpriteSymbol from "../../../../../../wx-ktv-build/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../wx-ktv-build/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-countdown-clock",
  "use": "icon-countdown-clock-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol viewBox=\"0 0 34 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-countdown-clock\">\n  <circle cx=\"17\" cy=\"17\" r=\"15\" stroke=\"currentColor\" stroke-width=\"3\" />\n  <path d=\"M17 9V17L25 22\" stroke=\"currentColor\" stroke-width=\"3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol